/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveAvailabilityRetrievePathOrgUnitId,
	OrgUnitReserveAvailabilityRetrieveQueryDate,
	OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes,
	OrgUnitReserveAvailabilityRetrieveQueryGuestsCount,
	OrgUnitReserveAvailabilityRetrieveQueryReserveId,
	OrgUnitReserveAvailabilityRetrieveStatus200,
} from "../types/OrgUnitReserveAvailabilityRetrieve.ts";

function getOrgUnitReserveAvailabilityRetrieveUrl(org_unit_id: OrgUnitReserveAvailabilityRetrievePathOrgUnitId) {
	const res = { method: "GET", url: `/api/org_unit/${org_unit_id}/reserve/availability/` as const };

	return res;
}

/**
 * @summary доступное время бронирования по залам и столам на дату
 * {@link /api/org_unit/:org_unit_id/reserve/availability/}
 */
export async function orgUnitReserveAvailabilityRetrieve(
	org_unit_id: OrgUnitReserveAvailabilityRetrievePathOrgUnitId,
	params: {
		date: OrgUnitReserveAvailabilityRetrieveQueryDate;
		duration_minutes?: OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes;
		guests_count: OrgUnitReserveAvailabilityRetrieveQueryGuestsCount;
		reserve_id?: OrgUnitReserveAvailabilityRetrieveQueryReserveId;
	},
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgUnitReserveAvailabilityRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgUnitReserveAvailabilityRetrieveUrl(org_unit_id).url.toString(),
		params,
		...requestConfig,
	});

	return res.data;
}
